export enum AddressField {
  id = 'id',
  customer_id = 'customer_id',
  first_name = 'first_name',
  last_name = 'last_name',
  address1 = 'address1',
  address2 = 'address2',
  address_type = 'address_type',
  city = 'city',
  postal_code = 'postal_code',
  phone = 'phone',
  state_or_province = 'state_or_province',
  country = 'country',
  country_code = 'country_code',
  company = 'company',
}

export interface Address {
  [AddressField.id]?: number;
  [AddressField.address1]: string;
  [AddressField.address2]: string;
  [AddressField.address_type]: string;
  [AddressField.city]: string;
  [AddressField.company]: string;
  [AddressField.country]: string;
  [AddressField.country_code]: string;
  [AddressField.customer_id]?: number;
  [AddressField.first_name]: string;
  [AddressField.last_name]: string;
  [AddressField.phone]: string;
  [AddressField.postal_code]: string;
  [AddressField.state_or_province]: string;
}
